import { ArrowLeft } from "lucide-react";
import { Logo } from "./landing/Logo";
import { Footer } from "./landing/Footer";

export const LegalLayout = ({ title, updated, intro, children }) => (
  <div className="min-h-screen bg-background">
    <header className="sticky top-0 z-40 border-b border-border bg-black/70 backdrop-blur-xl">
      <div className="mx-auto flex max-w-[900px] items-center justify-between px-6 py-4">
        <a href="/" className="flex items-center" data-testid="legal-logo-home">
          <Logo className="h-10" />
        </a>
        <a
          href="/"
          data-testid="legal-back-home"
          className="inline-flex items-center gap-2 text-sm text-muted-foreground transition-colors hover:text-foreground"
        >
          <ArrowLeft size={15} strokeWidth={1.5} /> Back to home
        </a>
      </div>
    </header>

    <main className="mx-auto max-w-[900px] px-6 py-16 lg:py-20">
      <span className="font-mono-ui text-[11px] font-bold uppercase tracking-[0.2em] text-primary">
        Legal
      </span>
      <h1 className="mt-4 font-heading text-4xl font-medium tracking-tight lg:text-5xl">{title}</h1>
      {updated ? (
        <p className="mt-3 font-mono-ui text-[11px] uppercase tracking-[0.15em] text-muted-foreground">
          Last updated: {updated}
        </p>
      ) : null}
      {intro ? (
        <p className="mt-8 text-base leading-relaxed text-muted-foreground">{intro}</p>
      ) : null}
      <div className="mt-10 space-y-10">{children}</div>
    </main>

    <Footer />
  </div>
);

export const Section = ({ heading, children }) => (
  <section>
    <h2 className="font-heading text-xl font-medium tracking-tight text-foreground lg:text-2xl">
      {heading}
    </h2>
    <div className="mt-4 space-y-4 text-[15px] leading-relaxed text-muted-foreground">{children}</div>
  </section>
);

export const Bullets = ({ items }) => (
  <ul className="space-y-2">
    {items.map((it, i) => (
      <li key={i} className="flex gap-3">
        <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-primary" />
        <span>{it}</span>
      </li>
    ))}
  </ul>
);
